import React from 'react';
import { motion } from 'framer-motion';

export const VoiceVisualizer = ({ isActive = false, volume = 0.5 }) => {
  const bars = Array.from({ length: 5 });

  return (
    <div className="flex items-center justify-center gap-1.5 h-16" data-testid="voice-visualizer">
      {bars.map((_, i) => (
        <motion.div
          key={i}
          className="w-2 bg-lime rounded-full"
          animate={{
            height: isActive ? `${(Math.random() * 40 + 20) * volume}px` : '8px',
            opacity: isActive ? 1 : 0.3,
          }}
          transition={{
            duration: 0.3,
            repeat: isActive ? Infinity : 0,
            repeatType: 'reverse',
            delay: i * 0.1,
          }}
        />
      ))}
    </div>
  );
};

export default VoiceVisualizer;